import crypto from "crypto-js";
import { chartStatusConstants, milestoneConstants, qcStatusConstants } from "../../utils/constants";
import { doesChartNoExistInSystem } from "../../services/chartService";
let strRegex = new RegExp(/^[a-z0-9]+$/i);
// eslint-disable-next-line no-useless-escape
let strRegexPrimaryDiagnosis = new RegExp(/^[a-zA-Z0-9\.,_\-!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?]+$/i);
// eslint-disable-next-line no-useless-escape
let strRegexForEmModifierProcCode = new RegExp(/^[a-zA-Z0-9\.,_\-!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?]+$/i);

const ChartFormValidationRules = async (values, clientData, masterData, configureField) => {
  let errors = {};

  const isPropertyRequired = (property) => {
    const fieldRule = configureField?.find((rule) => rule.field === property);

    if (!fieldRule) return {};

    const isRequired = fieldRule.validation === "M";
    const notMandatory = fieldRule.validation === "NM";
    const isHidden = fieldRule.validation === "NA";

    return {
      className: `${isRequired ? "required" : ""} form-label`,
      required: isRequired,
      notMandatory: notMandatory,
      hidden: isHidden,
    };
  };

  const chartNumberProperties = isPropertyRequired("chart_no");

  if (values.hasOwnProperty("chart_no") && !chartNumberProperties?.hidden) {
    if ((values?.chart_no === "" || values?.chart_no === null) && !chartNumberProperties?.notMandatory) {
      errors.chart_no = "Required";
    } else if (chartNumberProperties?.notMandatory || chartNumberProperties?.required) {
      let result = strRegex.test(values?.chart_no);
      if (!result) {
        errors.chart_no = "Only alphanumeric allowed";
      }
    }
    if(values?.chart_no !== null && values?.chart_no !== "" && clientData?.MilestoneId !== milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID) {
      const response = await doesChartNoExistInSystem(clientData?.Id, values?.chart_no,{
        ClientId: clientData?.ClientId, 
        LocationId: clientData?.LocationId, 
        ProcessId: clientData?.ProcessId,
        DOS: values?.date_of_service,
      });
      if(response?.doesExist) {
        errors.chart_no = "Chart number already exists";
        window.toastr.error(errors.chart_no);
      }
    }
    
  }

  const mrNumberProperties = isPropertyRequired("mr_no");

  if (values.hasOwnProperty("mr_no") && !mrNumberProperties?.hidden) {
    let mrNum = values?.mr_no !== null ? crypto.AES.decrypt(values?.mr_no, process.env.REACT_APP_SECRET_PASS).toString(crypto.enc.Utf8) : "";
    if ((mrNum === "" || mrNum === null) && !mrNumberProperties?.notMandatory) {
      errors.mr_no = "Required";
    } else if (mrNumberProperties?.notMandatory || mrNumberProperties?.required) {
      let isNum = /^[A-Z]*\d+$/.test(mrNum);
      if (!isNum && mrNum !== "") {
        errors.mr_no = "Please enter valid MR number";
      }
    }
  }

  const admitDateProperties = isPropertyRequired("admit_date");

  if (values.hasOwnProperty("admit_date") && !admitDateProperties?.hidden) {
    if ((values?.admit_date === "" || values?.admit_date === null) && !admitDateProperties?.notMandatory) {
      errors.admit_date = "Required";
    }
  }

  const dischargeDateProperties = isPropertyRequired("discharge_date");

  if (values.hasOwnProperty("discharge_date") && !dischargeDateProperties?.hidden) {
    if ((values?.discharge_date === "" || values?.discharge_date === null) && !dischargeDateProperties?.notMandatory) {
      errors.discharge_date = "Required";
    }
  }

  const subSpecialProperties = isPropertyRequired("sub_specialty");

  if (values.hasOwnProperty("SubSpecialtyId") && !subSpecialProperties?.hidden) {
    if ((values?.SubSpecialtyId === "" || values?.SubSpecialtyId === null || values?.SubSpecialtyId === undefined || values?.SubSpecialtyId?.length === 0) && !subSpecialProperties?.notMandatory) {
      errors.sub_specialty = "Required";
    }
  }

  const dispositionProperties = isPropertyRequired("disposition");

  if (values.hasOwnProperty("DispositionId") && !dispositionProperties?.hidden) {
    if ((values?.DispositionId === "" || values?.DispositionId === null || values?.DispositionId === undefined || values?.DispositionId?.length === 0) && !dispositionProperties?.notMandatory) {
      errors.DispositionId = "Required";
    }
  }

  const primaryHealtProperties = isPropertyRequired("primary_health");

  if (values.hasOwnProperty("PrimaryHealthId") && !primaryHealtProperties?.hidden) {
    if ((values?.PrimaryHealthId === "" || values?.PrimaryHealthId === null || values?.PrimaryHealthId === undefined ) && !primaryHealtProperties?.notMandatory) {
      errors.primary_health = "Required";
    }
  }

  const facilityProperties = isPropertyRequired("facility");

  if (values.hasOwnProperty("FacilityId") && !facilityProperties?.hidden) {
    if ((values?.FacilityId === "" || values?.FacilityId === null || values?.FacilityId === undefined) && !facilityProperties?.notMandatory) {
      errors.facility = "Required";
    }
  }

  const emProperties = isPropertyRequired("em");

  if (values.hasOwnProperty("em") && !emProperties?.hidden) {
    if ((values?.em === "" || values?.em === null) && !emProperties?.notMandatory) {
      if (emProperties?.required) {
        errors.em = "Required";
      }
    } else if (emProperties?.notMandatory || emProperties?.required) {
      let result = strRegexForEmModifierProcCode.test(values?.em);
      if (!result) {
        errors.em = "Only alphanumeric and special characters allowed. Remove spaces if any.";
      }
    }
  }

  const poaProperties = isPropertyRequired("poa");

  if (values.hasOwnProperty("poa") && !poaProperties?.hidden) {
    if ((values?.poa === "" || values?.poa === null) && !poaProperties?.notMandatory) {
      if (poaProperties?.required) {
        errors.poa = "Required";
      }
    } else if (poaProperties?.notMandatory || poaProperties?.required) {
      let result = strRegex.test(values?.poa);
      if (!result) {
        errors.poa = "Only alphanumeric allowed";
      }
    }
  }

  const losProperties = isPropertyRequired("los");

  if (values.hasOwnProperty("los") && !losProperties?.hidden) {
    if ((values?.los === "" || values?.los === null) && !losProperties?.notMandatory) {
      if (losProperties?.required) {
        errors.los = "Required";
      }
    } else if (losProperties?.notMandatory || losProperties?.required) {
      let result = strRegex.test(values?.los);
      if (!result) {
        errors.los = "Only alphanumeric allowed";
      }
    }
  }

  const drgProperties = isPropertyRequired("drg");

  if (values.hasOwnProperty("drg_value") && !drgProperties?.hidden) {
    if ((values?.drg_value === "" || values?.drg_value === null) && !drgProperties?.notMandatory) {
      if (drgProperties?.required) {
        errors.drg_value = "Required";
      }
    } else if (drgProperties?.notMandatory || drgProperties?.required) {
      let result = strRegex.test(values?.drg_value);
      if (!result) {
        errors.drg_value = "Only alphanumeric allowed";
      }
    }
  }

  const procedureProperties = isPropertyRequired("procedure_code");

  if (values.hasOwnProperty("procedure_code") && !procedureProperties?.hidden) {
    if ((values?.procedure_code === "" || values?.procedure_code === null) && !procedureProperties?.notMandatory) {
      if (procedureProperties?.required) {
        errors.procedure_code = "Required";
      }
    } else if (procedureProperties?.notMandatory || procedureProperties?.required) {
      let result = strRegexForEmModifierProcCode.test(values?.procedure_code);
      if (!result) {
        errors.procedure_code = "Only alphanumeric and special characters allowed. Remove spaces if any.";
      }
    }
  }

  if (values.hasOwnProperty("AuditOptions")) {
    if (values?.AuditOptions === null || values?.AuditOptions === undefined || values?.AuditOptions?.length === 0) {
      errors.AuditOptionsId = "Required";
    }
  }

  const primaryDiagnosisProperties = isPropertyRequired("primary_diagnosis");

  if (values.hasOwnProperty("primary_diagnosis") && !primaryDiagnosisProperties?.hidden) {
    if ((values?.primary_diagnosis === "" || values?.primary_diagnosis === null) && !primaryDiagnosisProperties?.notMandatory) {
      if (primaryDiagnosisProperties?.required) {
        errors.primary_diagnosis = "Required";
      }
    } else if (primaryDiagnosisProperties?.notMandatory || primaryDiagnosisProperties?.required) {
      let result = strRegexPrimaryDiagnosis.test(values?.primary_diagnosis);
      if (!result) {
        errors.primary_diagnosis = "Only alphanumeric and special characters allowed. Remove spaces if any.";
      }
    }
  }

  const rejectionCommentsProperties = isPropertyRequired("rejection_comments");

  if (values.hasOwnProperty("denial_comments") && !rejectionCommentsProperties?.hidden) {
    if ((values?.denial_comments === "" || values?.denial_comments === null) && !rejectionCommentsProperties?.notMandatory) {
       errors.denial_comments = "Required";
    }
  }

  const deficiencyCommentsProperties = isPropertyRequired("deficiency_comments");

  if (values.hasOwnProperty("deficiency_comments") && !deficiencyCommentsProperties?.hidden) {
    if ((values?.deficiency_comments === "" || values?.deficiency_comments === null) && !deficiencyCommentsProperties?.notMandatory) {
       errors.deficiency_comments = "Required";
    }
  }

  const responsiblePartiesProperties = isPropertyRequired("responsible_parties");

  if (values.hasOwnProperty("ResponsibleParties") && !responsiblePartiesProperties?.hidden) {
    if ((values?.ResponsibleParties === "" || values?.ResponsibleParties === null || values?.ResponsibleParties?.length === 0 || values.ResponsibleParties === undefined) && !responsiblePartiesProperties?.notMandatory) {
      errors.ResponsibleParties = "Required";
    }
  }

  const dateOfServiceProperties = isPropertyRequired("date_of_service");

  if (values.hasOwnProperty("date_of_service") && !dateOfServiceProperties?.hidden) {
    if ((values?.date_of_service === "" || values?.date_of_service === null) && !dateOfServiceProperties?.notMandatory) {
      errors.date_of_service = "Required";
    }
  }

  if (values.hasOwnProperty("QCStatusId")) {
    if (clientData?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID && values?.QCStatusId === qcStatusConstants.QC_FAIL_ID) {
      errors.QC_status = "Update qc status";
    }
    if (clientData?.MilestoneId === milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID && (values?.QCStatusId === qcStatusConstants.QC_IMPLEMENTED_ID || values?.QCStatusId === qcStatusConstants.QC_REJECTED_ID || values?.QCStatusId === null)) {
      errors.QC_status = "Update qc status";
    }
  }

  const chartStatusProperties = isPropertyRequired("chart_status");

  if (values.hasOwnProperty("StatusId") && !chartStatusProperties?.hidden) {
    if ((values?.StatusId === null || values?.StatusId === undefined || values?.StatusId?.length === 0) && !chartStatusProperties?.notMandatory) {
      errors.chart_status = "Required";
    }
  }
  if (values?.StatusId === chartStatusConstants.INCOMPLETE_STATUS_ID && !chartStatusProperties?.hidden) {
  }
  if (values?.StatusId === chartStatusConstants.OPEN_STATUS_ID & !chartStatusProperties?.hidden) {
    errors.chart_status = "Choose incomplete or complete";
  } else {
  }
  if (values?.StatusId === chartStatusConstants.INCOMPLETE_STATUS_ID && !chartStatusProperties?.hidden) {
    if (values.hasOwnProperty("HoldReasons")) {
      if (values?.HoldReasons?.length === 0) {
        errors.HoldReasons = "Required";
      }
    }
  }
  if (values?.hasOwnProperty("HoldReasons")) {
    values?.HoldReasons?.find(function (ele) {
      return ele === 28;
    });
  }

  const coderProperties = isPropertyRequired("coder_comments");

  if ((values?.hasOwnProperty("coder_comments") && clientData?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID && values.StatusId !== chartStatusConstants.COMPLETE_STATUS_ID) && !coderProperties?.hidden) {
    if ((values?.coder_comments?.trim() === "" || values?.coder_comments === null) && !coderProperties?.notMandatory) {
      errors.coder_comments = "Required";
    }
  }
  if (values?.StatusId === chartStatusConstants.COMPLETE_STATUS_ID) {
  } else {
  }
  if (clientData?.hasOwnProperty("comment") && values?.comment_msg === null && values?.StatusId !== chartStatusConstants.COMPLETE_STATUS_ID) {
    errors.comment_msg = "Required";
    window.toastr.error("Please enter a comment in the conversation log");
  }
  return errors;
};
export default ChartFormValidationRules;
